import { render } from "./HistoricoPedidosCanceladosLiquidados.vue?vue&type=template&id=47bee696&scoped=true"
import script from "./HistoricoPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"
export * from "./HistoricoPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"

import "./HistoricoPedidosCanceladosLiquidados.vue?vue&type=style&index=0&id=47bee696&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bee696"]])

export default __exports__